import colors from './config/colors';
import commonStyles from './config/commonStyles';
import components from './config/components';
import fonts from './config/fonts';
import fontSizes from './config/fontSizes';
import inputs from './config/inputs';
import layout from './config/layout';
import project from './config/project';
import { routing } from './config/routes';
import spacing from './config/spacing';
import translations from './config/translations';
import views from './config/views';

export const CONFIG = {
	project: { ...project },
	colors: { ...colors, loadingModalBackground: colors.primaryLighter },
	fonts: { ...fonts },
	fontSizes: { ...fontSizes },
	spacing: { ...spacing },
	routing: { ...routing },
	translations: { ...translations },
	commonStyles: { ...commonStyles },
	inputs: { ...inputs },
	layout: {
		header: { ...layout.header },
	},
	components: {
		mainWrapper: { ...components.mainWrapper },
		progressBar: { ...components.progressBar },
		backNextButton: { ...components.backNextButton },
	},
	views: {
		signatureRead: { ...views.signatureRead },
		identityBiometrics: { ...views.identityBiometrics },
	},
	contactPhone: {
		label: '914 100 617',
		value: '+34914100617',
	},
};
